import Immutable from 'seamless-immutable';
import Collection from './';

/**
 * Transforms an array of backend collection objects into a CollectionCollection
 * @typedef {Object} Response
 * @param {Object[]} content - backend formatted collections
 * @param {Object} meta - meta information related to content
 * @returns {Object} Containing collections{Collection[]} and count{Number} properties
 */
function deserialize({ content = [], meta: { count } }) {
  return Immutable({
    collections: _.map(content, Collection.Model.deserialize),
    count,
  });
}

function search(value, collections) {
  return _.filter(collections, collection => {
    const collectionSearchRegExp = new RegExp(value, 'i');
    return collectionSearchRegExp.test(collection.name) || collectionSearchRegExp.test(collection.id);
  });
}

const create = deserialize;

export default {
  create,
  deserialize,
  search,
};

export { create, deserialize, search };
